import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getMasters() {
  const response = await http.getData("/rpd-dewasa-masters").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/rpd-dewasa`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/rpd-dewasa/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/rpd-dewasa", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/rpd-dewasa/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/rpd-dewasa/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

// Pencarian ICD-10 (reuse endpoint referensi existing)
async function searchIcd(term: string) {
  const response = await http
    .getDataParam("/referensi/diagnosis-icd/search", { params: { term } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Pencarian obat formularium lokal (c_phar)
async function searchObat(term: string) {
  const response = await http
    .getDataParam("/referensi/obat/search", { params: { term } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Pencarian KFA nasional (c_kfa)
async function searchKfa(term: string) {
  const response = await http
    .getDataParam("/referensi/kfa/search", { params: { term } })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

export default {
  getMasters,
  getByRegister,
  find,
  create,
  update,
  destroy,
  searchIcd,
  searchObat,
  searchKfa
};
